import React, { useState, useEffect, useContext } from 'react';
import { Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { getContent } from '../../api';
import adminContext from '../../context/adminContext';
import Loading from '../../components/Loading';

function Login() {
  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [state, setState] = useState('loading');
  const [errorMsg, setError] = useState(' ');
  const [logo, setLogo] = useState(null);

  const { userData, setUserData } = useContext(adminContext);
  const { t } = useTranslation();
  const history = useHistory();

  useEffect(() => {
    if (userData.userId && userData.userId !== 'LOADING' && userData.userId !== 'INVALID') {
      axios
        .get(`${process.env.REACT_APP_API_URI}/api/admin/${userData.userId}`)
        .then(() => {
          setState('already-auth');
        })
        .catch(() => {
          setState('error');
        });
    } else {
      setState('loading');
    }

    getContent()
      .then((res) => {
        setLogo(res.data.main[1].image);
        setState('success');
      })
      .catch();
  }, []);

  const submit = async (e) => {
    e.preventDefault();

    axios.post(
      `${process.env.REACT_APP_API_URI}/api/admin/login`,
      { email, password },
    )
      .then(((loginRes) => {
        setUserData({
          token: loginRes.data.token,
          user: loginRes.data.user_id,
        });
        localStorage.setItem('auth-token', loginRes.data.token);
        window.location.href = '/backoffice';
      }))
      .catch((err) => {
        setState('error');
        if (err.response !== undefined) {
          setError(err.response.data.message);
        } else {
          setError(500);
        }
      });
  };

  if (state === 'loading') {
    return (
      <>
        <Loading />
      </>
    );
  }

  if (state === 'already-auth') {
    setState('success');
  }

  return (
    <div className="login">
      <button type="button" className="go-back-button" onClick={() => { history.goBack(); }}>
        {t('goBack')}
      </button>
      <div className="d-flex flex-wrap vertical-align justify-content-center mb-5 mt-5">
        <div className="">
          <div className="login-input">
            <div className="login-logo">
              <img src={`${process.env.REACT_APP_API_URI}/api/image/${logo}`} alt="" width="179" height="120" />
            </div>

            <Form className="login-form" action="" method="post" onSubmit={submit}>
              <Form.Group controlId="email-control">
                <Form.Label>Email</Form.Label>
                <Form.Control type="email" placeholder="name@example.com" onChange={(e) => setEmail(e.target.value)} />
              </Form.Group>
              <Form.Group controlId="password-control">
                <Form.Label>Password</Form.Label>
                <Form.Control type="password" placeholder="*******" onChange={(e) => setPassword(e.target.value)} />
              </Form.Group>
              <div><small className="text-danger pre-wrap">{state === 'error' && errorMsg}</small></div>
              <Form.Group className="login-row">
                <input type="submit" className="login-button" value="Login" />
              </Form.Group>
            </Form>
            <a className="login-forget" href="/request_password_recover">Esqueceu-se da palavra-passe?</a>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Login;
